// ===========================================
// MarkedByCaption (#42 Phase 4)
// ===========================================
// "Marked by Sarah Lee · 16/09/2026" under an attendance status, or
// "Marked by: not recorded" for a mark made before #42. Staff surfaces only.

import { Typography } from '@mui/material';
import { useSchoolTimezone } from '../../contexts/TenantContext';
import { markedByText } from './markedBy.utils';

interface MarkedByCaptionProps {
  markedByName: string | null | undefined;
  markedAt: string | Date | null | undefined;
}

export default function MarkedByCaption({ markedByName, markedAt }: MarkedByCaptionProps) {
  const timeZone = useSchoolTimezone();
  return (
    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
      {markedByText(markedByName, markedAt, timeZone)}
    </Typography>
  );
}
